"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineStem = determineStem;

var _lodashEs = require("lodash-es");

var _detectAndStemRegularParticiple = require("./detectAndStemRegularParticiple");

var _flattenSortLength = require("../morphoHelpers/flattenSortLength");

var _stem = require("./stem");

var _stem2 = _interopRequireDefault(_stem);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Returns a stem for a word that appears on the noun exception lists.
 *
 * @param {Object}  morphologyDataNouns The German morphology data for nouns.
 * @param {string}  stemmedWord         The stem to check.
 *
 * @returns {string|null} The stemmed word or null if none was found.
 */


var findStemOnNounExceptionList = function findStemOnNounExceptionList(morphologyDataNouns, stemmedWord) {
  var exceptionStems = morphologyDataNouns.exceptionStems;

  var _iterator = _createForOfIteratorHelper(exceptionStems),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var exceptionStemSet = _step.value;
      var matchedStem = exceptionStemSet.find(function (exceptionStem) {
        return stemmedWord.endsWith(exceptionStem);
      });

      if (matchedStem) {
        var precedingLexicalMaterial = stemmedWord.slice(0, stemmedWord.length - matchedStem.length);
        return precedingLexicalMaterial + exceptionStemSet[0];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
};
/**
 * Returns a stem for a word that appears on the adjective exception lists.
 *
 * @param {Object}  morphologyDataAdjectives    The German morphology data for adjectives.
 * @param {string}  stemmedWord                 The stem to check.
 *
 * @returns {string|null} The stemmed word or null if none was found.
 */


var findStemOnAdjectiveExceptionList = function findStemOnAdjectiveExceptionList(morphologyDataAdjectives, stemmedWord) {
  var adjectiveExceptionClasses = morphologyDataAdjectives.exceptions;

  for (var _i = 0, _Object$keys = Object.keys(adjectiveExceptionClasses); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var exceptionStems = adjectiveExceptionClasses[key];

    var _iterator2 = _createForOfIteratorHelper(exceptionStems),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var exceptionStemSet = _step2.value;

        if (exceptionStemSet.includes(stemmedWord)) {
          return exceptionStemSet[0];
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return null;
};
/**
 * Returns a stem for a word that appears on the verb exception lists.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  stemmedWord         The stem to check.
 *
 * @returns {string|null} The stemmed word or null if none was found.
 */


var findStemOnVerbExceptionList = function findStemOnVerbExceptionList(morphologyDataVerbs, stemmedWord) {
  var wordToCheck = stemmedWord;
  var strongAndIrregularVerbStems = morphologyDataVerbs.strongAndIrregularVerbs.stems;
  var prefixes = (0, _flattenSortLength.flattenSortLength)(morphologyDataVerbs.prefixes);
  var matchedPrefix = prefixes.find(function (prefix) {
    return stemmedWord.startsWith(prefix);
  });

  if (matchedPrefix) {
    var wordWithoutPrefix = wordToCheck.slice(matchedPrefix.length, wordToCheck.length);
    /* At least 3 characters so that e.g. "be" is not found in the stem "berg". A minimum length of 3 was chosen
     * as a safe option, since 2-letter verb stems are highly unlikely to impossible.
     */

    if (wordWithoutPrefix.length > 2) {
      wordToCheck = wordWithoutPrefix;
    } else {
      matchedPrefix = null;
    }
  }

  var _iterator3 = _createForOfIteratorHelper(strongAndIrregularVerbStems),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var strongOrIrregularVerbParadigm = _step3.value;
      var stems = strongOrIrregularVerbParadigm.stems;
      stems = (0, _lodashEs.flatten)(Object.values(stems));

      if (stems.includes(wordToCheck)) {
        if (matchedPrefix) {
          // The present tense stem is returned as a default stem.
          return matchedPrefix + strongOrIrregularVerbParadigm.stems.present;
        }

        return strongOrIrregularVerbParadigm.stems.present;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
};
/**
 * Returns the stem for a given German input word.
 *
 * @param   {string} word                   The word to get the stem for.
 * @param   {Object} morphologyDataGerman   The German morphology data.
 *
 * @returns {string} Stemmed form of the word.
 */


function determineStem(word, morphologyDataGerman) {
  var verbData = morphologyDataGerman.verbs;
  var stemmedWord = (0, _stem2.default)(verbData, word);
  /*
   * Goes through the stem exception functions from left to right, returns the first stem it finds.
   * If no stem has been found, return the original, programmatically created, stem.
   */

  return findStemOnNounExceptionList(morphologyDataGerman.nouns, stemmedWord) || findStemOnAdjectiveExceptionList(morphologyDataGerman.adjectives, stemmedWord) || findStemOnVerbExceptionList(verbData, stemmedWord) || (0, _detectAndStemRegularParticiple.detectAndStemRegularParticiple)(verbData, word) || stemmedWord;
}